// source: package_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.Package', null, global);
goog.exportSymbol('proto.Package.PackageType', null, global);
goog.exportSymbol('proto.PackageList', null, global);
goog.exportSymbol('proto.RawPackageList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Package = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Package, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Package.displayName = 'proto.Package';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PackageList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PackageList.repeatedFields_, null);
};
goog.inherits(proto.PackageList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PackageList.displayName = 'proto.PackageList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.RawPackageList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.RawPackageList.repeatedFields_, null);
};
goog.inherits(proto.RawPackageList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.RawPackageList.displayName = 'proto.RawPackageList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Package.prototype.toObject = function(opt_includeInstance) {
  return proto.Package.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Package} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Package.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
data: msg.getData_asB64(),
encrypted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
sourceUserId: jspb.Message.getFieldWithDefault(msg, 4, 0),
targetUserId: jspb.Message.getFieldWithDefault(msg, 5, 0),
id: jspb.Message.getFieldWithDefault(msg, 6, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 7, 0),
targetIdentityId: jspb.Message.getFieldWithDefault(msg, 8, 0),
sentByBackhaul: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
timestamp: jspb.Message.getFieldWithDefault(msg, 10, 0),
imei: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Package}
 */
proto.Package.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Package;
  return proto.Package.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Package} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Package}
 */
proto.Package.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Package.PackageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEncrypted(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSourceUserId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTargetUserId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setWorkspaceId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTargetIdentityId(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSentByBackhaul(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setImei(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Package.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Package.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Package} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Package.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getEncrypted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSourceUserId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getTargetUserId();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getTargetIdentityId();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getSentByBackhaul();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      10,
      f
    );
  }
  f = message.getImei();
  if (f !== 0) {
    writer.writeUint64(
      11,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.Package.PackageType = {
  MESSAGE: 0,
  RAW: 1,
  PART: 2,
  FORECAST: 3,
  FORECASTREQUEST: 4,
  SOSMESSAGE: 5,
  TRACKINGSESSION: 6,
  TRACKINGLOCATION: 7,
  PACKAGELIST: 8,
  TRACKINGDELTA: 9,
  CREATEWAYPOINT: 10,
  WAYPOINT: 11,
  ENCRYPTEDPACKAGE: 12,
  ENCRYPTIONREQUEST: 13,
  DELETEROUTE: 14,
  MEDIA: 15,
  TAKSHAPE: 16,
  TAKMESSAGE: 17,
  CREATEEXTERNALUSER: 18,
  REGISTRATIONREQUEST: 19,
  TRACKINGALTITUDEDELTA: 20,
  CREATEHEALTHACTIVITY: 21,
  HEALTHACTIVITY: 22,
  DEVICESTATUS: 23,
  SETTINGSREQUEST: 24,
  MEDIAPART: 25,
  UPDATEUSERACCOUNT: 26,
  USERACCOUNT: 27,
  USERIDENTITY: 28,
  SENSORDATA: 29,
  ROUTEDRAWDATA: 30,
  TRACKINGALTITUDESPEEDCOURSEDELTA: 31,
  TRACKINGSPEEDCOURSEDELTA: 32,
  MESSAGEREACTION: 33,
  LOGCOMMAND: 34,
  TRACKINGLOCATIONCOLLECTION: 35,
  DEVICESETTINGSSYNC: 36,
  CASEVACPREVIEW: 37,
  FILE: 38,
  WORKSPACE: 39,
  REQUESTLOGUPLOAD: 40,
  COT: 41,
  FILEMETADATA: 42,
  BLOCKCHUNKDATA: 43,
  MESHPACKET: 44,
  TELEMETRY: 45,
  SENSORSTATUS: 46,
  DEVICEFORWARD: 47,
  HARDWAREFACTORYRESET: 48,
  REGISTRATIONINVOKE: 49,
  REGISTRATIONUPDATED: 50,
  PING: 51
};

/**
 * optional PackageType type = 1;
 * @return {!proto.Package.PackageType}
 */
proto.Package.prototype.getType = function() {
  return /** @type {!proto.Package.PackageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Package.PackageType} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bytes data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.Package.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.Package.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.Package.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional bool encrypted = 3;
 * @return {boolean}
 */
proto.Package.prototype.getEncrypted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setEncrypted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint64 source_user_id = 4;
 * @return {number}
 */
proto.Package.prototype.getSourceUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setSourceUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 target_user_id = 5;
 * @return {number}
 */
proto.Package.prototype.getTargetUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setTargetUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 id = 6;
 * @return {number}
 */
proto.Package.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 workspace_id = 7;
 * @return {number}
 */
proto.Package.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 target_identity_id = 8;
 * @return {number}
 */
proto.Package.prototype.getTargetIdentityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setTargetIdentityId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool sent_by_backhaul = 9;
 * @return {boolean}
 */
proto.Package.prototype.getSentByBackhaul = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setSentByBackhaul = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional fixed32 timestamp = 10;
 * @return {number}
 */
proto.Package.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint64 imei = 11;
 * @return {number}
 */
proto.Package.prototype.getImei = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.Package} returns this
 */
proto.Package.prototype.setImei = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PackageList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PackageList.prototype.toObject = function(opt_includeInstance) {
  return proto.PackageList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PackageList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PackageList.toObject = function(includeInstance, msg) {
  var f, obj = {
packagesList: jspb.Message.toObjectList(msg.getPackagesList(),
    proto.Package.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PackageList}
 */
proto.PackageList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PackageList;
  return proto.PackageList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PackageList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PackageList}
 */
proto.PackageList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Package;
      reader.readMessage(value,proto.Package.deserializeBinaryFromReader);
      msg.addPackages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PackageList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PackageList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PackageList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PackageList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Package.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Package packages = 1;
 * @return {!Array<!proto.Package>}
 */
proto.PackageList.prototype.getPackagesList = function() {
  return /** @type{!Array<!proto.Package>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Package, 1));
};


/**
 * @param {!Array<!proto.Package>} value
 * @return {!proto.PackageList} returns this
*/
proto.PackageList.prototype.setPackagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Package=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Package}
 */
proto.PackageList.prototype.addPackages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Package, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PackageList} returns this
 */
proto.PackageList.prototype.clearPackagesList = function() {
  return this.setPackagesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.RawPackageList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.RawPackageList.prototype.toObject = function(opt_includeInstance) {
  return proto.RawPackageList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RawPackageList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.RawPackageList.toObject = function(includeInstance, msg) {
  var f, obj = {
packagesList: jspb.Message.toObjectList(msg.getPackagesList(),
    proto.Package.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RawPackageList}
 */
proto.RawPackageList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.RawPackageList;
  return proto.RawPackageList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RawPackageList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RawPackageList}
 */
proto.RawPackageList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Package;
      reader.readMessage(value,proto.Package.deserializeBinaryFromReader);
      msg.addPackages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.RawPackageList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.RawPackageList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RawPackageList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.RawPackageList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Package.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Package packages = 1;
 * @return {!Array<!proto.Package>}
 */
proto.RawPackageList.prototype.getPackagesList = function() {
  return /** @type{!Array<!proto.Package>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Package, 1));
};


/**
 * @param {!Array<!proto.Package>} value
 * @return {!proto.RawPackageList} returns this
*/
proto.RawPackageList.prototype.setPackagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Package=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Package}
 */
proto.RawPackageList.prototype.addPackages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Package, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.RawPackageList} returns this
 */
proto.RawPackageList.prototype.clearPackagesList = function() {
  return this.setPackagesList([]);
};


goog.object.extend(exports, proto);
